/* cl-live.js — RETRABALHO 2026-08-24.

   O operador reprovou: "os comentarios e avaliacoes nao carregam" e "todas as sessoes
   onde tem um slide para passar para o proximo ficaram estaticas".

   Duas causas distintas:

   1) CARROSSEL EM MODO SCROLLER. O `cl-overrides.css` (regra 11) desmonta o flickity
      congelado abaixo de 768px com `display:contents` — o tema do concorrente REALMENTE
      faz isso nas GRADES. Só que ali as celulas viram uma faixa rolavel e ninguem passou
      a comandar essa faixa: o `cl-interactions.js` desiste justamente quando ve
      `display:contents` (build() devolve null). Resultado no mobile: setas e bolinhas
      inertes e o carrossel parado no meio do caminho. Aqui a faixa rolavel vira o
      carrossel: setas, bolinhas e swipe passam a rolar ate a celula certa.

   2) WIDGET DE AVALIACOES (Okendo). O widget e um app injetado por JS; o `extract`
      capturou o HTML renderizado, entao ele APARECE, mas nenhum clique faz nada — abas,
      "Afficher plus", filtro por estrelas, ordenacao, carrossel de fotos e voto "utile"
      sao todos do app. Este arquivo reimplementa esses comportamentos sobre o markup
      copiado, com as avaliacoes extras vindo de um <script type="application/json"
      data-cl-more-reviews> que a propria secao carrega.

   Tudo e delegado no document e restrito as secoes copiadas — nada toca o tema. */
(function () {
  'use strict';

  var SEC = '[class*="cl-sec-"]';

  function arr(x) { return Array.prototype.slice.call(x); }
  function vis(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  /* ================================================== 1. carrossel vivo ===
     O concorrente usa QUATRO markups de slider e nenhum deles chega com JS:
       .oi-slider      (dele; a variante `--fade` empilha e troca por opacidade)
       .oi-reviews     (dele, o carrossel de depoimentos)
       .flickity-*     (tema Pipeline)
       .hooper-*       (dentro do widget Okendo)
     Cada um vira um "rig" {vp, track, cells, mode} e passa a andar por seta e bolinha.
     O movimento e por `scrollLeft` quando a janela de fato rola, por `translateX` na
     faixa quando ela e `overflow:hidden` travada, e por opacidade no modo fade. */

  var KINDS = [
    { root: '.oi-slider',
      vp: '.oi-slider__viewport', track: '.oi-slider__track', cell: '.oi-slider__slide',
      dot: '.oi-slider__dot', active: 'is-active' },
    { root: '[class*="oi-reviews"]',
      vp: '[class*="oi-reviews__viewport"]', track: '[class*="oi-reviews__track"]', cell: null,
      dot: '.oi-slider__dot', active: 'is-active' },
    { root: '.flickity-enabled, .flickity-grid, [data-product-slideshow], .related__products',
      vp: '.flickity-viewport', track: '.flickity-slider', cell: '.flickity-cell',
      dot: '.flickity-page-dots .dot', active: 'is-selected' },
    { root: '.hooper, .oke-mediaCarousel',
      vp: '.hooper-list', track: '.hooper-track', cell: '.hooper-slide',
      dot: '.hooper-indicator', active: 'is-active' }
  ];

  function rigIn(host) {
    for (var k = 0; k < KINDS.length; k++) {
      var K = KINDS[k];
      var vp = host.matches(K.vp) ? host : host.querySelector(K.vp);
      if (!vp) continue;
      var track = vp.querySelector(K.track);
      if (!track) {
        track = arr(vp.children).filter(function (n) { return n.nodeType === 1; })[0];
      }
      if (!track) continue;
      var cells = K.cell ? arr(track.querySelectorAll(K.cell))
                         : arr(track.children).filter(function (n) { return n.nodeType === 1; });
      if (cells.length < 2) continue;
      var lefts = cells.map(function (c) { return c.offsetLeft; });
      var spread = Math.max.apply(null, lefts) - Math.min.apply(null, lefts);
      var fadeHost = vp.closest('[class*="--fade"]');
      var fade = spread < 6 || !!fadeHost;
      return { kind: K, host: host, vp: vp, track: track, cells: cells,
               mode: fade ? 'fade' : 'slide' };
    }
    return null;
  }

  /* Do botao ate o slider: sobe pelos "roots" conhecidos e so entao cai na secao. */
  function rigOf(el) {
    var sels = KINDS.map(function (K) { return K.root; }).join(', ');
    var host = el.closest(sels);
    var rig = host ? rigIn(host) : null;
    if (rig) return rig;
    var up = el.parentElement;
    for (var i = 0; i < 6 && up; i++) {
      rig = rigIn(up);
      if (rig) return rig;
      up = up.parentElement;
    }
    var sec = el.closest('.shopify-section');
    return sec ? rigIn(sec) : null;
  }

  function trackShift(track) {
    // O extract congela a faixa em `translate3d(-1475px,0,0)` — nao so `translateX`.
    var t = track.style.transform || '';
    var m = /translate3d\((-?[\d.]+)px/.exec(t) || /translateX\((-?[\d.]+)px\)/.exec(t);
    return m ? -parseFloat(m[1]) : 0;
  }

  /* A janela pode ter scrollWidth > clientWidth e MESMO ASSIM nao rolar: com
     `overflow:hidden` o Chrome ignora scrollLeft. Testa uma vez, de verdade. */
  function usesScroll(rig) {
    if (rig.vp.__clScroll !== undefined) return rig.vp.__clScroll;
    // Se a faixa chegou com `transform` INLINE, foi assim que o slider do concorrente
    // se movia — e foi assim que o extract a congelou. Mexer no scroll nesse caso nao
    // sai do lugar: a janela ate aceita scrollLeft, mas quem desloca e o transform.
    if (/translate/i.test(rig.track.style.transform || '')) {
      rig.vp.__clScroll = false;
      return false;
    }
    var ok = false;
    if (rig.vp.scrollWidth - rig.vp.clientWidth > 8) {
      var before = rig.vp.scrollLeft;
      rig.vp.scrollLeft = before + 10;
      ok = Math.abs(rig.vp.scrollLeft - before) > 1;
      rig.vp.scrollLeft = before;
    }
    rig.vp.__clScroll = ok;
    return ok;
  }

  function indexOfRig(rig) {
    if (rig.mode === 'fade') {
      for (var i = 0; i < rig.cells.length; i++) {
        if (rig.cells[i].classList.contains(rig.kind.active) ||
            rig.cells[i].classList.contains('is-selected')) return i;
      }
      return 0;
    }
    var x = usesScroll(rig) ? rig.vp.scrollLeft : trackShift(rig.track);
    var best = 0, bd = Infinity;
    for (var j = 0; j < rig.cells.length; j++) {
      var d = Math.abs((rig.cells[j].offsetLeft - rig.cells[0].offsetLeft) - x);
      if (d < bd) { bd = d; best = j; }
    }
    return best;
  }

  /* As bolinhas precisam ser as DESTA copia: cada secao existe duas vezes
     (`.cl-vd` do desktop e `.cl-vm` do mobile) e procurar na secao inteira acendia a
     bolinha da variante escondida. */
  function dotsOf(rig) {
    var host = rig.vp.closest('[class*="cl-vd"], [class*="cl-vm"]')
            || rig.vp.closest('.oi-slider, [class*="oi-reviews"], .flickity-enabled, .hooper')
            || rig.host.closest('.shopify-section')
            || rig.host;
    var d = arr(host.querySelectorAll(rig.kind.dot));
    return d.length ? d : arr((rig.host.closest('.shopify-section') || document)
                              .querySelectorAll(rig.kind.dot));
  }

  /* Pode haver MENOS bolinhas que celulas (elas contam paginas, nao slides). */
  function dotIndex(rig, cellIdx, n) {
    if (n >= rig.cells.length) return cellIdx;
    return Math.min(n - 1, Math.round(cellIdx * (n - 1) /
                                      Math.max(1, rig.cells.length - 1)));
  }

  function cellForDot(rig, dotIdx, n) {
    if (n >= rig.cells.length) return dotIdx;
    return Math.round(dotIdx * (rig.cells.length - 1) / Math.max(1, n - 1));
  }

  function syncDots(rig, i) {
    var dots = dotsOf(rig);
    var target = dotIndex(rig, i, dots.length);
    dots.forEach(function (d, j) {
      d.classList.toggle(rig.kind.active, j === target);
      if (d.hasAttribute('aria-selected')) {
        d.setAttribute('aria-selected', j === target ? 'true' : 'false');
      }
    });
  }

  function paintRig(rig, i) {
    i = Math.max(0, Math.min(i, rig.cells.length - 1));
    if (rig.mode === 'fade') {
      rig.cells.forEach(function (c, j) {
        c.style.opacity = j === i ? '1' : '0';
        c.style.pointerEvents = j === i ? '' : 'none';
        c.classList.toggle(rig.kind.active, j === i);
      });
    } else {
      var left = rig.cells[i].offsetLeft - rig.cells[0].offsetLeft;
      if (usesScroll(rig)) {
        try { rig.vp.scrollTo({ left: left, behavior: 'smooth' }); }
        catch (e) { rig.vp.scrollLeft = left; }
      } else {
        // a janela e `overflow:hidden` travada: quem anda e a faixa
        if (!rig.track.style.transition) rig.track.style.transition = 'transform .45s ease';
        rig.track.style.transform = 'translateX(' + (-left) + 'px)';
      }
      rig.cells.forEach(function (c, j) {
        c.classList.toggle(rig.kind.active, j === i);
        if (rig.kind.active !== 'is-selected') c.classList.toggle('is-selected', j === i);
      });
    }
    syncDots(rig, i);
    return i;
  }

  function isNext(el) {
    var t = ((el.getAttribute('aria-label') || '') + ' ' + (el.className || '') + ' ' +
             (el.innerText || '')).toLowerCase();
    if (/prev|précédent|precedent/.test(t)) return false;
    return /next|suivant/.test(t);
  }

  function isPrev(el) {
    var t = ((el.getAttribute('aria-label') || '') + ' ' + (el.className || '') + ' ' +
             (el.innerText || '')).toLowerCase();
    return /prev|précédent|precedent/.test(t);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('button, [role="button"], a');
    if (!el) return;
    if (el.closest('[data-cl-pdp], #cl-kcart')) return;   // buybox novo e gaveta: JS proprio
    if (el.closest('[data-cl-own] .flickity-enabled, [data-cl-own] [data-oi-slider]')) return;   // carrossel proprio (cl-orl.js)
    if (!el.closest(SEC) && !el.closest('[class*="oke-"], [class*="oi-slider"]')) return;

    // bolinha
    if (/dot|indicator/i.test((el.className || '').toString())) {
      var rigD = rigOf(el);
      if (rigD) {
        var ds = dotsOf(rigD);
        var idx = ds.indexOf(el);
        if (idx >= 0) {
          e.preventDefault(); e.stopPropagation();
          paintRig(rigD, cellForDot(rigD, idx, ds.length));
          return;
        }
      }
    }
    if (!isNext(el) && !isPrev(el)) return;
    var rig = rigOf(el);
    if (!rig) return;
    var cur = indexOfRig(rig);
    var to = isNext(el) ? cur + 1 : cur - 1;
    if (to >= rig.cells.length) to = 0;
    if (to < 0) to = rig.cells.length - 1;
    e.preventDefault(); e.stopPropagation();
    paintRig(rig, to);
  }, true);

  /* bolinha acompanha o dedo quando a janela rola de verdade */
  function watchScrollers() {
    var sels = KINDS.map(function (K) { return K.root; }).join(', ');
    arr(document.querySelectorAll(sels)).forEach(function (host) {
      if (host.__clLive) return;
      if (host.closest('[data-cl-pdp]')) return;
      if (host.closest('[data-cl-own] [data-oi-slider]') || (host.matches && host.matches('[data-cl-own] [data-oi-slider]'))) return;
      var rig = rigIn(host);
      if (!rig) return;
      host.__clLive = true;
      // O extract pode congelar a faixa NO MEIO de uma animacao (`translate3d(-1475px…)`):
      // a pagina abre com dois cartoes cortados e nenhuma bolinha acesa. Normaliza — mas
      // SO nesse caso. Um carrossel que ja chegou alinhado numa celula fica intocado:
      // mexer nele por mexer desloca a secao e derruba o pixel-diff sem motivo.
      if (!host.__clHomed && rig.mode === 'slide') {
        host.__clHomed = true;
        var x = usesScroll(rig) ? rig.vp.scrollLeft : trackShift(rig.track);
        var alinhado = false;
        for (var q = 0; q < rig.cells.length; q++) {
          if (Math.abs((rig.cells[q].offsetLeft - rig.cells[0].offsetLeft) - x) <= 3) {
            alinhado = true; break;
          }
        }
        if (!alinhado) {
          var tr = rig.track.style.transition;
          rig.track.style.transition = 'none';
          paintRig(rig, 0);
          rig.track.offsetHeight;                     // aplica antes de religar a animacao
          rig.track.style.transition = tr || '';
        }
      }
      if (rig.mode === 'slide' && usesScroll(rig)) {
        var t = null;
        rig.vp.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () { syncDots(rig, indexOfRig(rig)); }, 90);
        }, { passive: true });
      }
      syncDots(rig, indexOfRig(rig));
    });
  }

  /* ============================================ 2. widget de avaliacoes ===
     Reimplementa, sobre o markup copiado do Okendo:
       - abas Avis / Questions
       - "Afficher plus" (revela mais cartoes, incluindo os do JSON extra)
       - filtro por estrelas (barras do histograma) e botao Filtres
       - ordenacao (Trier)
       - "Lire la suite"
       - voto "utile"
       - carrossel de fotos dos clientes (cai no modo scroller acima) */

  var PAGE = 5;

  function widgets() {
    return arr(document.querySelectorAll('.oke-w, [class*="oke-w-reviews"]'))
      .filter(function (w) { return w.querySelector('.oke-w-review'); })
      .filter(function (w, i, a) {                       // so o mais externo
        return !a.some(function (o) { return o !== w && o.contains(w); });
      });
  }

  function cardsOf(w) {
    return arr(w.querySelectorAll('.oke-w-reviews-list-item, .oke-w-review'))
      .filter(function (c) { return c.classList.contains('oke-w-reviews-list-item')
                                 || !c.closest('.oke-w-reviews-list-item'); });
  }

  function starsOf(card) {
    var fg = card.querySelector('.oke-reviewContent-stars .oke-stars-foreground, ' +
                                '.oke-stars-foreground');
    if (!fg) return 5;
    var m = /width:\s*([\d.]+)%/.exec(fg.getAttribute('style') || '');
    return m ? Math.round(parseFloat(m[1]) / 20) : 5;
  }

  function dateRank(card) {
    var t = (card.querySelector('.oke-w-review-createdDate, .oke-reviewContent-date') || {}).textContent || '';
    var m = /(\d+)\s*(heure|jour|semaine|mois|an)/i.exec(t);
    if (!m) return 0;
    var n = parseInt(m[1], 10);
    var unit = m[2].toLowerCase();
    var mult = unit.indexOf('heure') === 0 ? 1 / 24 :
               unit.indexOf('jour') === 0 ? 1 :
               unit.indexOf('semaine') === 0 ? 7 :
               unit.indexOf('mois') === 0 ? 30 : 365;
    return n * mult;                                   // maior = mais antigo
  }

  function state(w) {
    if (!w.__cl) {
      w.__cl = { shown: PAGE, filter: 0, sort: 'featured', cards: cardsOf(w) };
      w.__cl.order = w.__cl.cards.slice();
      injectExtra(w);
      w.__cl.cards = cardsOf(w);
      w.__cl.order = w.__cl.cards.slice();
    }
    return w.__cl;
  }

  /* avaliacoes extras raspadas do concorrente, cravadas na secao pelo build */
  function injectExtra(w) {
    // Cada secao existe DUAS vezes (variante `.cl-vd` do desktop e `.cl-vm` do mobile);
    // as duas precisam receber os cartoes extras. Remover a tag na primeira deixava a
    // do mobile — justamente a que o operador ve — sem nada para revelar.
    if (w.__clExtra) return;
    w.__clExtra = true;
    var sec = w.closest('.shopify-section') || document;
    var tag = sec.querySelector('script[type="application/json"][data-cl-more-reviews]');
    if (!tag) return;
    var data;
    try { data = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!data || !data.length) return;
    var list = w.querySelector('.oke-w-reviews-list, .oke-w-reviewsList') ||
               (w.querySelector('.oke-w-reviews-list-item') || {}).parentElement;
    var model = w.querySelector('.oke-w-reviews-list-item') || w.querySelector('.oke-w-review');
    if (!list || !model) return;
    data.forEach(function (r) {
      var node = model.cloneNode(true);
      node.setAttribute('data-cl-extra', '1');
      var set = function (sel, val) {
        var e = node.querySelector(sel);
        if (e && val != null) e.textContent = val;
      };
      set('.oke-w-reviewer-name', r.author || '');
      set('.oke-avatar-placeholder', r.initials || '');
      set('.oke-w-review-createdDate, .oke-reviewContent-date', r.date || '');
      set('.oke-reviewContent-title, .oke-w-review-title', r.title || '');
      set('.oke-bodyText', r.body || '');
      var fg = node.querySelector('.oke-stars-foreground');
      if (fg && r.stars) fg.setAttribute('style', 'width: ' + (r.stars * 20) + '%');
      // avatar: ou a foto real, ou so as iniciais
      var av = node.querySelector('.oke-avatar-image');
      if (av) {
        if (r.avatar) { av.setAttribute('src', r.avatar); av.removeAttribute('srcset'); }
        else { av.remove(); }
      }
      // fotos do cliente
      var media = node.querySelectorAll('.oke-reviewContent-media img, .oke-media-image');
      for (var i = 0; i < media.length; i++) {
        if (r.images && r.images[i]) {
          media[i].setAttribute('src', r.images[i]);
          media[i].removeAttribute('srcset');
        } else {
          var holder = media[i].closest('.oke-media') || media[i];
          holder.remove();
        }
      }
      var cnt = node.querySelector('.oke-helpful-vote-counter');
      if (cnt) cnt.textContent = '';
      list.appendChild(node);
    });
  }

  function apply(w) {
    var st = state(w);
    var list = st.order.slice();
    if (st.filter) {
      list = list.filter(function (c) { return starsOf(c) === st.filter; });
    }
    if (st.sort === 'newest') list.sort(function (a, b) { return dateRank(a) - dateRank(b); });
    else if (st.sort === 'oldest') list.sort(function (a, b) { return dateRank(b) - dateRank(a); });
    else if (st.sort === 'highest') list.sort(function (a, b) { return starsOf(b) - starsOf(a); });
    else if (st.sort === 'lowest') list.sort(function (a, b) { return starsOf(a) - starsOf(b); });

    st.cards.forEach(function (c) { c.style.display = 'none'; });
    var parent = list.length ? list[0].parentElement : null;
    list.forEach(function (c, i) {
      if (parent) parent.appendChild(c);
      c.style.display = i < st.shown ? '' : 'none';
    });

    var more = w.querySelector('.oke-showMore-button') ||
               arr(w.querySelectorAll('button')).filter(function (b) {
                 return /afficher plus|show more/i.test(b.innerText || '');
               })[0];
    if (more) more.style.display = list.length > st.shown ? '' : 'none';

    var count = w.querySelector('.oke-w-reviewsCount, .oke-w-filters-count');
    if (count && st.filter) count.textContent = list.length + ' avis';
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest('.oke-w, [class*="oke-w-reviews"]');
    if (!w) return;
    w = widgets().filter(function (x) { return x.contains(e.target); })[0] || w;

    // --- abas Avis / Questions
    var tab = e.target.closest('[role="tab"], .oke-w-tabs button, .oke-tabs button');
    if (tab) {
      e.preventDefault();
      var group = tab.closest('[role="tablist"], .oke-w-tabs, .oke-tabs') || w;
      var tabs = arr(group.querySelectorAll('[role="tab"], button'));
      var idx = tabs.indexOf(tab);
      tabs.forEach(function (t, i) {
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        t.classList.toggle('oke-is-active', i === idx);
        t.classList.toggle('oke-w-tabs-tab--active', i === idx);
      });
      var panels = arr(w.querySelectorAll('[role="tabpanel"], [id^="reviews-panel"], ' +
                                          '[id^="questions-panel"], .oke-w-tabPanel'));
      if (panels.length > 1) {
        panels.forEach(function (pnl, i) { pnl.hidden = i !== idx; pnl.style.display = i === idx ? '' : 'none'; });
      }
      return;
    }

    // --- Afficher plus
    var more = e.target.closest('.oke-showMore-button');
    if (!more) {
      var b = e.target.closest('button');
      if (b && /afficher plus|show more/i.test(b.innerText || '')) more = b;
    }
    if (more) {
      e.preventDefault();
      state(w).shown += PAGE;
      apply(w);
      return;
    }

    // --- barra do histograma: filtra por estrelas
    var bar = e.target.closest('.oke-w-breakdownModule-distribution-highlight, ' +
                               '.oke-w-breakdownModule-distribution-bar');
    if (bar) {
      e.preventDefault();
      var lbl = bar.getAttribute('aria-label') || '';
      var m = /(\d)\s*étoile/i.exec(lbl);
      var n = m ? parseInt(m[1], 10) : 0;
      var st = state(w);
      st.filter = (st.filter === n) ? 0 : n;
      st.shown = PAGE;
      apply(w);
      var grid = bar.closest('.oke-w-breakdownModule-distribution');
      if (grid) {
        arr(grid.querySelectorAll('.oke-w-breakdownModule-distribution-highlight'))
          .forEach(function (h) {
            var hm = /(\d)\s*étoile/i.exec(h.getAttribute('aria-label') || '');
            h.classList.toggle('oke-is-selected',
              !!(st.filter && hm && parseInt(hm[1], 10) === st.filter));
          });
      }
      return;
    }

    // --- botao Filtres: alterna "so com foto"
    var filt = e.target.closest('button');
    if (filt && /^\s*filtres?\s*$/i.test(filt.innerText || '')) {
      e.preventDefault();
      var s2 = state(w);
      s2.photoOnly = !s2.photoOnly;
      filt.classList.toggle('oke-is-active', s2.photoOnly);
      s2.order = s2.cards.filter(function (c) {
        return !s2.photoOnly || c.querySelector('.oke-reviewContent-media img, .oke-media-image');
      });
      s2.shown = PAGE;
      apply(w);
      return;
    }

    // --- Lire la suite
    var rm = e.target.closest('button, a');
    if (rm && /lire la suite|read more/i.test(rm.innerText || '')) {
      e.preventDefault();
      var card = rm.closest('.oke-w-review');
      if (card) {
        var body = card.querySelector('.oke-bodyText');
        if (body) {
          body.style.display = 'block';
          body.style.webkitLineClamp = 'unset';
          body.style.maxHeight = 'none';
          body.style.overflow = 'visible';
        }
        rm.style.display = 'none';
      }
      return;
    }

    // --- voto "utile"
    var vote = e.target.closest('.oke-helpful-vote-button');
    if (vote) {
      e.preventDefault();
      if (vote.__voted) return;
      vote.__voted = true;
      vote.classList.add('oke-is-active');
      var c = vote.querySelector('.oke-helpful-vote-counter') ||
              vote.parentElement.querySelector('.oke-helpful-vote-counter');
      if (c) {
        var num = parseInt((c.textContent || '').replace(/\D+/g, ''), 10);
        c.textContent = String((isNaN(num) ? 0 : num) + 1);
      }
      return;
    }
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('select');
    if (!sel) return;
    var w = widgets().filter(function (x) { return x.contains(sel); })[0];
    if (!w) return;
    var v = (sel.options[sel.selectedIndex] || {}).text || '';
    var st = state(w);
    st.sort = /récents/i.test(v) ? 'newest'
            : /anciens/i.test(v) ? 'oldest'
            : /élevée|haute|highest/i.test(v) ? 'highest'
            : /faible|basse|lowest/i.test(v) ? 'lowest'
            : 'featured';
    st.shown = PAGE;
    apply(w);
  }, true);

  /* ========================================== 3. preco do lote no botao ===
     O bloco nativo `quantity_selector` calcula o total do lote e mostra certinho
     dentro da caixa (R$ 84,99), mas o rotulo do ATC continua com o preco UNITARIO:
     o `update_prices` do tema so reage a troca de variante, nao a troca de faixa de
     quantidade. Sem isto o botao anuncia R$ 34,99 para um lote de 6 — pior do que
     nao mostrar preco nenhum. Espelha o preco da faixa selecionada. */

  function syncAtcPrice(scope) {
    var box = (scope || document).querySelector('.quantity-breaks-container');
    if (!box) return;
    var radios = arr(box.querySelectorAll('input[type="radio"][name="quantity"]'));
    var prices = arr(box.querySelectorAll('.quantity-break__price'));
    if (!radios.length || !prices.length) return;
    var i = radios.findIndex(function (r) { return r.checked; });
    if (i < 0 || i >= prices.length) return;
    var txt = (prices[i].textContent || '').replace(/\s+/g, ' ').trim();
    if (!txt) return;
    arr(document.querySelectorAll('.main-atc-price, .sticky-atc-price')).forEach(function (el) {
      var sep = /•/.test(el.textContent || '') ? ' •' : '';
      el.textContent = txt + sep;
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches &&
        e.target.matches('input[type="radio"][name="quantity"]')) {
      setTimeout(function () { syncAtcPrice(); }, 60);
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.quantity-breaks-container')) {
      setTimeout(function () { syncAtcPrice(); }, 220);
    }
  }, true);

  function boot() {
    watchScrollers();
    syncAtcPrice();
    widgets().forEach(function (w) {
      if (w.__clBooted) return;
      w.__clBooted = true;
      state(w);
      apply(w);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  window.addEventListener('resize', function () {
    clearTimeout(window.__clLiveT);
    window.__clLiveT = setTimeout(watchScrollers, 250);
  });
  // o widget e o carrossel podem aparecer depois (lazy): observa uma vez
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      clearTimeout(window.__clLiveM);
      window.__clLiveM = setTimeout(boot, 300);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }
})();
